<template>
  <div>
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      :searchDesc="searchDesc"
      @searchSubmit="searchSubmit"
      @delBtn="delBtn"
      @refresh-change="getlist"
      @etidSubmit="etidSubmit"
      @refreshBtn="refreshBtn"
    >
    </zx-table>
    <ele-form-dialog
      v-model="formData"
      :formDesc="formDesc"
      :request-fn="handleSubmit"
      :rules="rules"
      labelPosition="left"
      formBtnSize="mini"
      :dialogAttrs="{
        center: false,
        'destroy-on-close': true,
        'custom-class': 'formD'
      }"
      v-dialogdrag
      :visible.sync="dialogFormVisible"
      :title="formTitle"
    >
    </ele-form-dialog>
  </div>
</template>

<script>
import * as platform from "@/api/platform/platform.js";
import xzTable from "@/components/xz-table.vue";
export default {
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      searchDesc: {
        platform: {
          type: "input",
          label: "平台名称",
          attrs: {}
        },
        status: {
          label: "状态",
          type: "select",
          options: [
            {
              text: "启用",
              value: 1
            },
            {
              text: "关闭",
              value: -1
            }
          ]
        }
      },
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [1, 3, 10, 20, 30, 40, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "平台",
        // 多选 默认:false;
        selection: false,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: true,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: false,
        // 编辑 默认:true;
        editBtn: false,
        // 删除  默认:true;
        delBtn: false,
        // 折叠筐 默认:false;
        expand: false,
        expandStyle: "width:50%;display:inline-flex;",
        column: [
          {
            prop: "platform",
            // 列名
            label: "平台名称",
            hide: true,
            required: true,
            type: "select",
            options: [
              {
                text: "weixin",
                value: "weixin"
              },
              {
                text: "alipay",
                value: "alipay"
              },
              {
                text: "toutiao",
                value: "toutiao"
              }
            ]
          },
          {
            prop: "account",
            // 列名
            label: "appId",
            hide: true,
            required: true,
            type: "input"
          },
          {
            prop: "status",
            label: "状态",
            width: "100%",
            type: "select",
            show: "tag",
            hide: true,
            required: true,
            default: 1,
            options: [
              {
                text: "正常",
                value: 1
              },
              {
                text: "禁用",
                value: -1
              }
            ],
            tagtype: [
              {
                text: "正常",
                type: "success",
                value: 1
              },
              {
                text: "禁用",
                type: "danger",
                value: -1
              }
            ]
          },
          {
            prop: "create_time",
            // 列名
            label: "创建时间",
            hide: true,
            required: true,
            type: "input"
          }
        ],
        btnList: [
          {
            name: "编辑",
            type: "text",
            show: false,
            click: (id, row) => {
              this.formData = row;
              this.dialogFormVisible = true;
            }
          },
          {
            name: "删除",
            type: "text",
            show: false,
            click: id => {
              this.delBtn(id);
            }
          }
        ],
        btnNavLeft: [
          {
            text: "新增",
            size: "mini",
            type: "success",
            click: () => {
              this.formData = {};
              this.dialogFormVisible = true;
            }
          }
        ]
      },
      formTitle: "新增平台",
      tableData: [],
      dialogFormVisible: false,
      formData: {},
      formDesc: {
        platform: {
          type: "select",
          label: "平台名称",
          options: [
            {
              text: "weixin",
              value: "weixin"
            },
            {
              text: "alipay",
              value: "alipay"
            },
            {
              text: "toutiao",
              value: "toutiao"
            }
          ]
        },
        account: {
          type: "input",
          label: "平台名称"
        },
        status: {
          type: "select",
          label: "状态",
          default: 1,
          required: true,
          options: [
            {
              text: "启用",
              value: 1
            },
            {
              text: "关闭",
              value: -1
            }
          ]
        },
        setting: {
          label: "配置",
          type: "dynamic",
          attrs: {
            // 这里是数组
            columns: [
              {
                // 这里制定了类型
                type: "el-input",
                // 必须指定 valueKey
                valueKey: "key"
              },
              {
                type: "el-input",
                // 必须指定 valueKey
                valueKey: "value"
              }
            ]
          }
        }
      },
      rules: {
        platform: [{ required: true, message: "请选择所属平台" }],
        account: [{ required: true, message: "请填写appid" }],
        status: [{ required: true, message: "请选择状态" }],
        setting: [{ required: true, message: "请输入配置项" }]
      }
    };
  },
  created() {
    this.getlist();
  },
  methods: {
    // 表单提交
    handleSubmit(data) {
      if (data.id) {
        platform.editPlatform.r(data).then(res => {
          this.dialogFormVisible = false;
          this.getlist();
        });
      } else {
        platform.addPlatform.r(data).then(res => {
          this.dialogFormVisible = false;
          this.getlist();
        });
      }
    },
    // 编辑数据删选
    screeningEditData(data) {
      let editData = {
        id: data.cron_id,
        subject: data.subject,
        loop_type: data.loop_type,
        cron_file: data.cron_file,
        isopen: data.isopen,
        ...data.loop_daytime.loopDayTime
      };
      this.formData = editData;
      this.dialogFormVisible = true;
    },
    getlist(e) {
      let that = this;
      let param;
      if (e) {
        that.page = e;
        param = {
          page: e.currentPage,
          limit: e.pageSize
        };
      } else {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize
        };
      }
      if (this.searchData) {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
          ...this.searchData
        };
      }
      platform.getPlatform.r(param).then(res => {
        that.tableData = res.list;
        that.page.total = res.total;
      });
    },
    // 筛选条件
    searchSubmit(e) {
      this.searchData = e;
      this.getlist();
    },
    // 删除
    delBtn(id) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          platform.deletePlatform
            .r({
              id: id
            })
            .then(res => {
              this.$message.success("平台删除成功");
              this.getlist();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 刷新
    refreshBtn(e) {
      this.getlist();
    }
  }
};
</script>

<style lang="scss" scoped></style>
